import { createContext } from 'react';
import type { AdminAuthState, AdminUser } from '@/types/admin';

export interface AdminAuthContextValue {
  isAuthenticated: boolean;
  user: AdminUser | null;
  token: string | null;
  isLoading: boolean;
  error: string | null;
  signIn: () => Promise<void>;
  signOut: () => void;
  clearError: () => void;
  refreshAuth: () => void;
  getAuthHeaders: () => Record<string, string>;
}

export const AdminAuthContext = createContext<AdminAuthContextValue | null>(null);

export type AdminAuthSnapshot = Pick<AdminAuthState, 'isAuthenticated' | 'user' | 'token'>;
